import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 16,
    padding: '6px 12px',
    margin: '4px',
    display: 'inline-block',
    background: theme.palette.grey[300]
  },
  main: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  circle: {
    width: 8,
    height: 8,
    marginRight: 6,
    [theme.breakpoints.down('sm')]: {
      width: 6,
      height: 6,
      marginRight: 6
    },
    borderRadius: '50%',
    background: theme.palette.grey[700]
  },
  title: {
    fontWeight: 600
  }
}))
export default useStyles
